import React, { useEffect, useState } from "react";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";

const Hero = () => {
  const [webinar, setWebinar] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const AIRTABLE_TOKEN = process.env.REACT_APP_AIRTABLE_TOKEN_WEBINAR;
      const requestUrl = "https://api.airtable.com/v0/";
      const baseId = "appOpnlaeWhYPqlWu";
      const tableId = "tbliqHX6jDpdeALAT";

      const options = {
        method: "GET",
        headers: {
          authorization: `Bearer ${AIRTABLE_TOKEN}`,
        },
      };

      const res = await fetch(`${requestUrl}${baseId}/${tableId}`, options);
      const data = await res.json();
      setWebinar(data.records);
    };
    fetchData();
  }, []);

  return (
    <section className="relative font-poppins py-10">
      <div className="max-w-6xl mx-auto px-6">
        {/* Two-column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image (left on desktop, below title on mobile) */}
          <div className="flex justify-center order-2 md:order-1">
            {webinar.length > 0 ? (
              webinar.map((a) => (
                <img
                  key={a.id}
                  src={a.fields.Photo?.[0].url}
                  alt="Webinar"
                  className="rounded-xl shadow-lg object-cover w-full max-w-md md:max-w-lg"
                />
              ))
            ) : (
              <div role="status" className="flex justify-center items-center">
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-300 animate-spin fill-blue-600"
                  viewBox="0 0 100 101"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.59c0 27.61-22.39 50-50 50s-50-22.39-50-50 22.39-50 50-50 50 22.39 50 50z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.97 39.04c2.43-.64 3.9-3.13 3.05-5.49-1.72-4.73-4.14-9.18-7.19-13.2-3.97-5.23-8.93-9.7-14.7-13.34-5.67-3.31-11.93-5.47-18.48-6.36-5.01-.68-10.08-.6-15.02.23-2.47.41-3.92 2.91-3.28 5.34.64 2.42 3.13 3.88 5.59 3.54 3.81-.53 7.68-.55 11.49-.03 5.32.72 10.45 2.49 15.07 5.17 4.64 2.7 8.7 6.29 11.94 10.57 2.33 3.07 4.22 6.45 5.61 10.03.9 2.34 3.35 3.82 5.77 3.19z"
                    fill="currentFill"
                  />
                </svg>
              </div>
            )}
          </div>

          {/* Text (right on desktop, top on mobile) */}
          <div className="text-center md:text-left order-1 md:order-2">
            {/* Subheading */}
            <p className="text-2xl font-semibold tracking-wide text-blue-600 mb-3">
              <span className="text-black">Upcoming Webinar</span>
            </p>

            {/* Main Heading */}
            <h1 className="text-4xl sm:text-5xl font-semibold leading-tight mb-3">
              Join our <span className="text-green-600">Free Session</span>
            </h1>

            {/* Description */}
            <p className="text-lg text-gray-600 max-w-md mx-auto md:mx-0 mb-6">
              Learn from industry experts in our upcoming session.
              Seats are limited — reserve yours now.
            </p>

            {/* CTA for desktop */}
            <div className="hidden md:block">
              <a
                href="https://tally.so/r/w4Bz9A?utm_source=webi&utm_medium=page&utm_content=webinar&utm_campaign=registration"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md transition text-base font-medium"
              >
                Enrol Now
              </a>
            </div>
          </div>

          {/* CTA for mobile (below image) */}
          <div className="text-center order-3 md:hidden mt-6">
            <a
              href="https://tally.so/r/w4Bz9A?utm_source=webi&utm_medium=page&utm_content=webinar&utm_campaign=registration"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md transition text-base font-medium"
            >
              Enrol Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;